import React from "react";
import { TSub } from "../../../../pages/configurations/components/ExamsConfigs";

interface SubjectCardProps {
  subject: {
    subjectId: TSub;
    approved: boolean;
  };
  isUpdating: boolean;
  onToggleApproval: (subjectId: string, currentStatus: boolean) => void;
}

const SubjectCard = ({
  subject,
  isUpdating,
  onToggleApproval,
}: SubjectCardProps) => {
  const { subjectId, approved } = subject;
  return (
    <div
      className={`
        group p-4 rounded-2xl border transition-all duration-300
        ${
          approved
            ? "bg-white border-gray-100 hover:border-primary/30 hover:shadow-lg"
            : "bg-orange-50/30 border-orange-100 hover:shadow-md"
        }
      `}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="w-10 h-10 bg-gray-50 rounded-xl flex items-center justify-center text-primary font-bold group-hover:bg-primary group-hover:text-white transition-all">
          {subjectId.name.charAt(0)}
        </div>
        <div className="flex flex-col items-end">
          <span
            className={`
            px-2.5 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider border
            ${
              approved
                ? "bg-green-50 text-green-600 border-green-100"
                : "bg-orange-100 text-orange-700 border-orange-200"
            }
          `}
          >
            {approved ? "Approved" : "Action Required"}
          </span>
        </div>
      </div>

      <h3 className="font-bold text-gray-800 text-lg mb-1">{subjectId.name}</h3>
      <p className="text-xs text-gray-400 mb-4 flex items-center gap-1 italic">
        {approved
          ? "Student has full access to content"
          : "Awaiting admin verification"}
      </p>

      <button
        onClick={() => onToggleApproval(subjectId._id, approved)}
        disabled={isUpdating}
        className={`
          w-full py-2.5 rounded-xl text-xs font-bold transition-all active:scale-95 flex items-center justify-center gap-2
          ${
            approved
              ? "bg-gray-100 text-gray-600 hover:bg-red-50 hover:text-red-600"
              : "bg-primary text-white hover:bg-primary/90 shadow-sm shadow-primary/20"
          }
          ${isUpdating ? "opacity-50" : ""}
        `}
      >
        {isUpdating ? (
          <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
        ) : approved ? (
          <>Revoke Access</>
        ) : (
          <>Approve Subject</>
        )}
      </button>
    </div>
  );
};

export default SubjectCard;
